//# sourceMappingURL=my-month-labels.interface.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/mydatepicker/dist/interfaces/my-month-labels.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-month-labels.interface.js
// module chunks = 4